{{option.labelLocalized}}
<!--{{option}}-->
<!--this is the sprout-slider-poll-label.component.html-->


